import { SELECIONAR_ROTA } from '../../actions/types'

const initialState = undefined;

export default function reducerRotaSelecionada (state = null, action = initialState) {
  switch (action.type) {
    case SELECIONAR_ROTA: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
